import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { IBcContestStudentCourse, IBcContestStudentData } from '../../../models/BcContest';
import { BcContestService } from '../../../services/bc-contest.service';

@Component({
    templateUrl: './bc-contest-preferences.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestPreferencesComponent {
    constructor(
        private service: BcContestService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: {
        student: IBcContestStudentData,
        courses: IBcContestStudentCourse[]
    }) {
        this.student = value.student;
        this.courses = [...value.courses];
    }

    wantedPoints: number;
    maxPoints: number;
    courses: IBcContestStudentCourse[] = [];

    isSaving: boolean;

    private student: IBcContestStudentData;
    private removed: IBcContestStudentCourse[] = [];

    up(course: IBcContestStudentCourse) {
        const ix = this.courses.indexOf(course);

        if (ix > 0) {
            const sub = this.courses[ix - 1];
            this.courses[ix - 1] = course;
            this.courses[ix] = sub;
        }
    }

    down(course: IBcContestStudentCourse) {
        const ix = this.courses.indexOf(course);

        if (ix < this.courses.length - 1) {
            const sub = this.courses[ix + 1];
            this.courses[ix + 1] = course;
            this.courses[ix] = sub;
        }
    }

    toggle(course: IBcContestStudentCourse) {
        const ix = this.removed.indexOf(course);

        if (ix == -1) {
            this.removed.push(course);
        } else {
            this.removed.splice(ix, 1);
        }
    }

    isRemoved(course: IBcContestStudentCourse) {
        return this.removed.includes(course);
    }

    save() {
        this.isSaving = true;

        const update = () => {
            this.service.updatePreferences(this.student.Id, {
                applicationPriority: this.courses.map(t => t.ApplicationId)
            }).pipe(finalize(() => {
                this.isSaving = false;
            })).subscribe(data => {
                this.courses.forEach(t => {
                    t.Priority = data.find(n => n.Id == t.ApplicationId)?.Priority;
                });

                this.activeModal.close();
            });
        };

        setTimeout(() => {
            if (this.removed.length) {
                forkJoin(this.removed.map(t => this.service.removeApplication(t.ApplicationId))).subscribe(() => {
                    this.removed.forEach(t => {
                        t.ApplicationId = undefined;
                    });
                    update();
                });
            } else {
                update();
            }
        }, 500);
    }

    close() {
        this.activeModal.dismiss();
    }
}
